import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Landscaping } from "./components/landscaping";
import { About } from "./components/about";
import { Testimonials } from "./components/testimonials";
import { GalleryComponent } from "./components/gallery";
import { FAQ } from "./components/faq";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Landscaping data={landingPageData.Landscaping} />
      <Testimonials data={landingPageData.Testimonials} />
      <GalleryComponent data={landingPageData.GalleryComponent} />
      <FAQ data={landingPageData.FAQ} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
